import { gql } from "@apollo/client";

export const updateWebLens = gql`
    mutation updateWebLens($input: UpdateWebLensRequest!) {
        updateWebLens(input: $input) {
            lensId
            status
            validation {
                name
                passed
                detail
            }
        }
    }
`;
